<template>
    <div id="history-account-status">
        <main id="mainContent" class="padFixBoth">
            <div class="view mt-4">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 col-sm-12 mt-4">

                            <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy"
                                     :items="pagination.data">
                                <template #cell(contrato)="{item}">
                                    {{ item.relclient?.sku }}
                                </template>
                                <template #cell(cliente)="{item}">
                                    <span v-if="item.tipo_per==1">
                                        {{ item.relclient?.nombre }} {{
                                            item.relclient?.paterno
                                        }} {{ item.relclient?.materno }}
                                    </span>
                                    <span v-else>
                                        {{ item.relclient?.nmComPerMoral }}
                                    </span>
                                </template>
                                <template #cell(plan)="{item}">
                                    {{ item.relpackage.paquete }}
                                </template>
                                <template #cell(prima_neta)="{item}">
                                    {{ item.prima_neta }}
                                </template>
                                <template #cell(comision)="{item}">
                                    {{ item.relpromoter.comision }}%
                                </template>
                                <template #cell(total)="{item}">
                                    {{ getObjRow(item).f_total }}
                                </template>
                                <template #cell(iva)="{item}">
                                    <span v-if="role_id===2">
                                      {{ getObjRow(item).f_iva }}
                                    </span>
                                    <span v-if="role_id===5">
                                       {{ getObjRow(item).f_iva }}
                                    </span>
                                </template>
                                <template v-if="type_per.tipo_per===1" #cell(ret.iva)="{item}">
                                    {{ getObjRow(item).f_ret_iva }}
                                </template>
                                <template v-if="type_per.tipo_per===1" #cell(ret.isr)="{item}">
                                    {{ getObjRow(item).f_ret_isr }}
                                </template>
                                <template #cell(total_a_pagar)="{item}">
                                    {{ getObjRow(item).f_total_a_pagar }}
                                </template>
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                            </b-table>
                            <div
                                style="background-color: #0069a7; color: #fff; text-align: center; padding: 10px 0; text-transform: uppercase;">
                                total global
                                <span>{{ globalTotal }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {quotersService} from "../../Services/Quoters.service";
import {agentsService} from "../../Services/Agents.service";
import {promotersService} from "../../Services/Promoters.service";
import {supplierspecialistService} from "../../Services/SupplierSpecialist.service";

export default {
    name: "history-account-status",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            default: 0,
            require: false
        },
        role_id: {
            type: Number,
            default: 0,
            require: true
        }
    },
    data() {
        return {
            isBusy: false,
            filter: null,
            quotings: [],
            fields: [],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            params: {
                limit: 10,
                page: 1,
                where: [],
            },
            type_per: []

        }
    },
    methods: {
        async index() {

            let field_bd = '';
            let s_c = '';
            let s_f = '';
            this.isBusy = true;

            switch (this.role_id) {
                case 2:
                    field_bd = 'agent_id';
                    s_c = 's_c_a';
                    s_f = 's_f_a';
                    this.type_per = await agentsService.getOne(this.user_id);
                    break;
                case 5:
                    field_bd = 'promoter_id';
                    s_c = 's_c_p';
                    s_f = 's_f_p';
                    this.type_per = await promotersService.getOne(this.user_id);
                    break;
                case 4:
                    field_bd = 'client_id';
                    s_c = 's_c_c';
                    s_f = 's_f_c';
                    this.type_per = await supplierspecialistService.getOne(this.user_id);
                    break;
            }

            //NECESITO SABER SI ES DE TIPO FISICO O MORAL
            if (this.type_per.tipo_per === 1) {
                //FISICA
                this.fields = [
                    {key: 'contrato'},
                    {key: 'cliente'},
                    {key: 'plan'},
                    {key: 'prima_neta'},
                    {key: 'comision'},
                    {key: 'total'},
                    {key: 'iva'},
                    {key: 'ret.iva'},
                    {key: 'ret.isr'},
                    {key: 'total_a_pagar'},
                ]
            } else {
                //MORAL
                this.fields = [
                    {key: 'contrato'},
                    {key: 'cliente'},
                    {key: 'plan'},
                    {key: 'prima_neta'},
                    {key: 'comision'},
                    {key: 'total'},
                    {key: 'iva'},
                    {key: 'total_a_pagar'},
                ]
            }

            this.params.where = [
                {field: field_bd, value: this.user_id, operator: '='},
                {field: s_c, value: 0, operator: '='},
                {field: s_f, value: 0, operator: '='},
                {field: 'approved_at', value: null, operator: '!='},
            ];

            this.pagination = await quotersService.findQuotes(this.params);

            this.isBusy = false;

        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },

        getObjRow(item) {
            //console.log(item)
            let f_ret_iva = 0;
            let f_ret_isr = 0;
            let com_iva = 0;
            let f_total = 0;
            let f_iva = 0;
            let f_subtotal = 0;
            let f_total_a_pagar = 0;
            let com = 0;
            switch (this.role_id) {
                case 2:
                    if (item.relagent) {
                        //console.log('AGENTE Y SU IVA Y COMISION ES: ', item.relagent.iva_agente, item.relagent.comision);
                        com_iva = item.relagent.iva_agente;
                        com = item.relagent.comision;
                    }
                    break;
                case 5:
                    if (item.relpromoter) {
                        com_iva = item.relpromoter.iva_promotor;
                        com = item.relpromoter.comision;
                    }
                    break;
            }

            //console.log('item.prima_base=', item.prima_base);
            if (item.prima_base !== undefined && item.prima_base !== null && item.prima_base !== '') {
                f_total = this.getTotalRow(item.prima_base, com);
                f_iva = this.getIvaRow(com_iva, f_total);
                f_subtotal = this.getSubtotalRow(f_total, f_iva);

                if (this.type_per.tipo_per === 1) {
                    f_ret_iva = this.getRetIvaRow(f_iva);
                    f_ret_isr = this.getRegIsrRow(f_total);
                }
                f_total_a_pagar = this.getTotalToPayRow(f_total, f_iva, f_ret_iva, f_ret_isr);
            }

            return {
                f_iva, f_total, f_subtotal, f_ret_iva, f_ret_isr, f_total_a_pagar

            }
        },
        getTotalRow(_total, _comision) {
            //console.log('_total=', _total, '_comision = ', _comision);
            let total = Number(_total.replace(/[^0-9\.-]+/g, ""));
            //console.log('total = ' + total);
            return this.formatCurrency(total * (_comision / 100));
        },
        getIvaRow(_iva_percent, _total) {
            //console.log('getIvaRow = ', _total, _iva_percent);
            let total = Number(_total.replace(/[^0-9\.-]+/g, ""));
            return this.formatCurrency(total * (_iva_percent / 100));
        },
        getSubtotalRow(_total, _iva) {
            let total = Number(_total.replace(/[^0-9\.-]+/g, ""));
            let iva = Number(_iva.replace(/[^0-9\.-]+/g, ""));
            return this.formatCurrency(total + iva);
        },
        getRetIvaRow(f_iva) {
            //console.log('f_iva= ', f_iva);
            let _f_iva = Number(f_iva.replace(/[^0-9\.-]+/g, ""));
            return this.formatCurrency((_f_iva / 3) * 2);
        },
        getRegIsrRow(f_total) {
            let total = Number(f_total.replace(/[^0-9\.-]+/g, ""));
            return this.formatCurrency(total * 0.1);
        },
        getTotalToPayRow(f_total, f_iva, f_ret_iva, f_ret_isr) {
            let total = Number(f_total.replace(/[^0-9\.-]+/g, ""));
            let _f_iva = Number(f_iva.replace(/[^0-9\.-]+/g, ""));
            let ret_iva = 0;
            let ret_isr = 0;
            if (f_ret_iva !== 0) {
                ret_iva = Number(f_ret_iva.replace(/[^0-9\.-]+/g, ""));
            }
            if (f_ret_isr !== 0) {
                ret_isr = Number(f_ret_isr.replace(/[^0-9\.-]+/g, ""));
            }
            return this.formatCurrency(((total + _f_iva) - (ret_iva + ret_isr)));
        },

    },
    computed: {
        globalTotal() {
            return this.formatCurrency(this.pagination.data.reduce((a, b) => a + Number(this.getObjRow(b).f_total_a_pagar.replace(/[^0-9\.-]+/g, "")), 0));
            //return 0;
        }
    },
    mounted() {
        this.index();
    }
}
</script>

<style scoped>
</style>
